module.exports = __webpack_public_path__ + "static/img/open_member_vip_bg_y.b420692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/open_member_vip_bg_y.png
// module id = 72DQ
// module chunks = 1